import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Components from "@/pages/Components";
import MaterialFlows from "@/pages/MaterialFlows";
import ProductBOMs from "@/pages/ProductBOMs";
import Inventory from "@/pages/Inventory";
import ProductionPlanning from "@/pages/ProductionPlanning";
import SalesOrders from "@/pages/SalesOrders";
import DeliveryOrders from "@/pages/DeliveryOrders";
import Machines from "@/pages/Machines";
import PurchaseOrders from "@/pages/PurchaseOrders";
import OperationalExpenses from "@/pages/OperationalExpenses";
import CoPackerInventory from "@/pages/CoPackerInventory";
import OperationsDashboard from "@/pages/OperationsDashboard";
import Contacts from "./pages/Contacts";
import Settings from "./pages/Settings";

import Layout from "@/components/Layout";
import { Loader2 } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-[#002FA7]" />
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="flex min-h-screen items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-[#002FA7]" />
      </div>
    );
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Components />} />
              <Route path="/material-flows" element={<MaterialFlows />} />
              <Route path="/product-boms" element={<ProductBOMs />} />
              <Route path="/inventory" element={<Inventory kind="components" />} />
              <Route path="/finished-goods" element={<Inventory kind="finished" />} />
              <Route path="/copacker-inventory" element={<CoPackerInventory />} />
              <Route path="/dashboard" element={<OperationsDashboard />} />
              <Route path="/production-planning" element={<ProductionPlanning />} />
              <Route path="/purchase-orders" element={<PurchaseOrders />} />
              <Route path="/operational-expenses" element={<OperationalExpenses />} />
              <Route path="/sales-orders" element={<SalesOrders />} />
              <Route path="/delivery-orders" element={<DeliveryOrders />} />
              <Route path="/machines" element={<Machines />} />
              <Route path="/contacts" element={<Contacts />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/suppliers" element={<Navigate to="/contacts?tab=suppliers" replace />} />
              <Route path="/land-freight" element={<Navigate to="/contacts?tab=land-freight" replace />} />
              <Route path="/company-directory" element={<Navigate to="/contacts?tab=company" replace />} />
              <Route path="/manufacturing-orders" element={<Navigate to="/production-planning" replace />} />
              <Route path="/production-reports" element={<Navigate to="/production-planning" replace />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
